import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  Tabs,
  Tab,
  Paper,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import { Gavel, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import AuctionCard from '../components/AuctionCard';
import api from '../services/api';

const Auctions = () => {
  const navigate = useNavigate();
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    fetchAuctions();
  }, [tabValue]);

  const fetchAuctions = async () => {
    setLoading(true);
    setError('');

    try {
      let url = '/auctions';

      if (tabValue === 0) {
        url = '/auctions/active';
      } else if (tabValue === 1) {
        url = '/auctions/ended';
      }

      const response = await api.get(url);
      setAuctions(response.data.auctions || []);
    } catch (err) {
      setError('Failed to load auctions');
      console.error('Error fetching auctions:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box py={4}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Box display="flex" alignItems="center" gap={2}>
            <Gavel sx={{ fontSize: 40, color: 'primary.main' }} />
            <Typography variant="h4" fontWeight="bold">
              Online Auctions
            </Typography>
          </Box>
        </Box>

        <Paper sx={{ mb: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Active Auctions" />
            <Tab label="Ended Auctions" />
            <Tab label="All Auctions" />
          </Tabs>
        </Paper>

        {loading ? (
          <Box display="flex" justifyContent="center" py={8}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : auctions.length === 0 ? (
          <Paper sx={{ p: 8, textAlign: 'center' }}>
            <Gavel sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No Auctions Available
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {tabValue === 0 && 'There are no active auctions at this time.'}
              {tabValue === 1 && 'No auctions have ended yet.'}
              {tabValue === 2 && 'No auctions have been created.'}
            </Typography>
          </Paper>
        ) : (
          <Grid container spacing={3}>
            {auctions.map((auction) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={auction.id}>
                <AuctionCard auction={auction} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Container>
  );
};

export default Auctions;
